document.addEventListener('DOMContentLoaded', async function () {
  const customCart       = document.getElementById('custom-cart');
  const flyerLayout      = document.getElementById('flyer_layout');
  const flyerPlaceholder = document.getElementById('flyer_placeholder');
  const params           = new URLSearchParams(location.search);
  const promoIdRaw       = params.get('id');
  const promoIdNum       = Number(promoIdRaw);

  if (flyerLayout) flyerLayout.dataset.promo = promoIdRaw || '';

  if (CID && customCart && typeof getCart === 'function') {
    Promise.resolve()
      .then(() => getCart())
      .catch(err => console.error('Erro ao obter carrinho:', err));
  }

  if (Number.isFinite(promoIdNum) && promoIdNum > 0 && typeof window.loadFlyer === 'function') {
    await loadFlyer(promoIdNum, 1)

    const flyerCart = document.getElementById('flyer_cart');
    if (!flyerCart) return;

    flyerCart.addEventListener('click', function (e) {
      const flushLink = e.target.closest('a[data-flush]');
      if (flushLink) {
        e.preventDefault();

        if (typeof window.flushCart === 'function') {
          try { flushCart(e); } catch (err) { console.error('flushCart falhou:', err); }
        }

        return;
      }

      const goCartBtn = e.target.closest('button');
      if (goCartBtn) {
        location.assign('/cart');
      }
    });
  } else if (flyerPlaceholder) {
    flyerPlaceholder.innerHTML = `
      <div class="alert alert-danger">
        <h3 class="text-center p-5 text-danger">Não foi encontrado nenhum folheto para o URL indicado</h3>
      </div>`;
  }
});

function promoUrl() {
  const flyerLayout = document.getElementById('flyer_layout');
  const params = new URLSearchParams(location.search);
  const promoId = params.get('id');

  if (promoId && !flyerLayout?.dataset.customer) {
    try {
      if (typeof Cookies?.set === 'function') {
        Cookies.set('promo_url', location.href);
      }
    } catch (err) {
      console.warn('Não foi possível gravar promo_url em cookie:', err);
    }

    location.assign('/account/login');
  }
}

function cartCount() {
  const cartProductsCount = document.querySelector('.cart-products-count');
  if (!cartProductsCount) return;

  const flyerData  = Number(cartProductsCount.dataset.flyer  || 0);
  const basketData = Number(cartProductsCount.dataset.basket || 0);

  cartProductsCount.textContent = flyerData + basketData;
}

function getCart() {
  if (!CID2) return;

  fetch(`${ENDPOINT}?action=marvanejo_get_carts&customer=${encodeURIComponent(CID2)}&store=0`)
    .then(res => {
      if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
      const ct = res.headers.get('content-type') || '';
      return ct.includes('application/json') ? res.json() : res.text().then(JSON.parse);
    })
    .then(data => {
      const { status, quantities, total, prices, titles } = data || {};
      if (!Number(status)) return;

      const hasQuantities = Object.keys(quantities || {}).length > 0;
      if (hasQuantities) {
        document
          .querySelectorAll('table.shop_table tbody tr.products_warning')
          .forEach(tr => (tr.hidden = true));
      }

      const totalSum = Object.values(total || {}).reduce((acc, v) => acc + (Number(v) || 0), 0);
      document.querySelector('.cart-products-count')?.setAttribute('data-flyer', String(totalSum));

      const pricesSum = Object.values(prices || {}).reduce((acc, v) => acc + (Number(v) || 0), 0);

      const shopTable = document.querySelector('table.shop_table');
      if (shopTable) {
        const cartBox = shopTable.querySelector('tbody.cart-box');
        if (cartBox) {
          const frag = document.createDocumentFragment();

          for (const [flyerId, price] of Object.entries(prices || {})) {
            const tr = document.createElement('tr');
            tr.setAttribute('data-promo', flyerId);

            const tdImg = document.createElement('td');
            const img = document.createElement('img');
            img.src = `https://marvanejo.apps.bydas.com/storage/flyer-${flyerId}-1.webp`;
            img.height = 50;
            img.width = 50;
            img.style.objectFit = "cover";
            img.style.objectPosition = "center";
            tdImg.appendChild(img);

            const tdTitle = document.createElement('td');
            tdTitle.className = 'prod_title_flyer';
            const a = document.createElement('a');
            a.href = `/pages/promo?id=${encodeURIComponent(flyerId)}`;
            const spanTip = document.createElement('span');
            spanTip.style.fontSize = '10px';
            spanTip.style.textTransform = 'lowercase';
            spanTip.textContent = 'Clique aqui para ver os produtos';
            a.append(document.createTextNode(titles?.[flyerId] ?? ''), document.createElement('br'), spanTip);
            tdTitle.appendChild(a);

            const tdQty = document.createElement('td');
            tdQty.className = 'prod_quantity_flyer';
            tdQty.textContent = String(total?.[flyerId] ?? 0);

            const tdVal = document.createElement('td');
            tdVal.className = 'flyer_value';
            const priceFixed = Number(price || 0).toFixed(2);
            tdVal.setAttribute('value', priceFixed);
            tdVal.textContent = `€ ${priceFixed.replace('.', ',')}`;

            tr.append(tdImg, tdTitle, tdQty, tdVal);
            frag.appendChild(tr);
          }

          cartBox.prepend(frag);

          const subTotalEl = document.querySelector('.cart__subtotal');
          if (subTotalEl) {
            const currentStr = subTotalEl.getAttribute('cart-value') || '0';
            const current = parseFloat(String(currentStr).replace(',', '.')) || 0;
            const updated = (current + pricesSum).toFixed(2);
            const updatedDisplay = updated.replace('.', ',');
            subTotalEl.textContent = `€ ${updatedDisplay}`;
            subTotalEl.setAttribute('cart-value', updatedDisplay);
          }
        }
      }

      if (typeof getBasket === 'function') getBasket();
    })
    .catch(err => {
      console.error('Erro em marvanejo_get_carts:', err);
      showLoadingModal('Erro de comunicação! Tente novamente');
    })
    .finally(removeLoadingModal);
}

function loadFlyer(id, page) {
  if (!CID2) return;

  const END = ENDPOINT;
  const flyerLayout      = document.getElementById('flyer_layout');
  const flyerPlaceholder = document.getElementById('flyer_placeholder');
  const flyerCart        = document.getElementById('flyer_cart');
  const pagerNextBtn     = document.querySelector('#flyer_pager button[data-next]');
  const pagerPrevBtn     = document.querySelector('#flyer_pager button[data-prev]');
  const arrowRight       = document.querySelector('.flyer_pager_arrow .arrow_right');
  const arrowLeft        = document.querySelector('.flyer_pager_arrow .arrow_left');
  const arrowsBox        = document.querySelector('.flyer_pager_arrow');

  const qsa = (root, sel) => Array.from((root || document).querySelectorAll(sel));
  const setDisabled = (el, state) => { if (el) el.disabled = !!state; };
  const setClick = (el, handler) => { if (el) el.onclick = handler; };
  const show = el => { if (el) el.classList.remove('d-none'); };
  const hide = el => { if (el) el.classList.add('d-none'); };
  const cssDisplay = (els, val) => els.forEach(el => { el.style.display = val; });

  if (flyerPlaceholder) flyerPlaceholder.replaceChildren();
  if (flyerCart) {
    cssDisplay(qsa(flyerCart, 'a[data-flush]'), 'none');
    qsa(flyerCart, 'button').forEach(b => setDisabled(b, true));
  }

  const qs = new URLSearchParams({
    action: 'marvanejo_load_flyer',
    customer: String(CID2),
    id: String(id),
    page: String(page),
  });

  fetch(`${END}?${qs.toString()}`)
    .then(res => (res.ok ? res.text() : res.text().then(t => { throw new Error(`${res.status} ${res.statusText} – ${t}`); })))
    .then(text => {
      const data = typeof text === 'string' ? JSON.parse(text) : text;

      if (Number(data?.status) !== 1) {
        if (flyerPlaceholder) {
          flyerPlaceholder.insertAdjacentHTML(
            'beforeend',
            `<div class="alert alert-danger"><h3 class="text-center p-5 text-danger">${data?.msg || 'Não foi possível carregar o folheto.'}</h3></div>`
          );
        }
        return;
      }

      if (flyerLayout) flyerLayout.dataset.page = String(page);

      if (flyerPlaceholder && data.cover) {
        const img = document.createElement('img');
        img.src = data.cover;
        img.width = 100;
        img.style.width = '100%';
        flyerPlaceholder.appendChild(img);
      }

      if (flyerCart && Array.isArray(data.data) && data.data.length) {
        cssDisplay(qsa(flyerCart, 'a[data-flush]'), 'block');

        for (let i = 0; i < data.data.length; i++) {
          const item = data.data[i];
          const key = `${item.posx}-${item.posy}`;
          const lens = data.lengths ? data.lengths[key] : undefined;
          if (typeof window.placePoints === 'function') {
            try { placePoints(item, lens); } catch (e) { console.error('placePoints error:', e); }
          }
        }
      }

      if (data.next && Number(data.next) > 0) {
        setDisabled(pagerNextBtn, false);
        setClick(pagerNextBtn, () => loadFlyer(id, page + 1));

        setDisabled(arrowRight, false);
        setClick(arrowRight, () => loadFlyer(id, page + 1));
      } else {
        setDisabled(pagerNextBtn, true);
        setDisabled(arrowRight, true);
      }

      if (page > 1) {
        setDisabled(pagerPrevBtn, false);
        setClick(pagerPrevBtn, () => loadFlyer(id, page - 1));

        setDisabled(arrowLeft, false);
        setClick(arrowLeft, () => loadFlyer(id, page - 1));
      } else {
        setDisabled(pagerPrevBtn, true);
        setDisabled(arrowLeft, true);
        if (arrowsBox) arrowsBox.style.display = 'none';
      }

      if (typeof window.getPointsFromCart === 'function') {
        const customer = flyerLayout?.dataset.customer || '';
        try { getPointsFromCart(id, customer); } catch (e) { console.error('getPointsFromCart error:', e); }
      }
    })
    .catch(() => {
      if (flyerPlaceholder) {
        flyerPlaceholder.insertAdjacentHTML(
          'beforeend',
          `<div class="alert alert-danger"><h3 class="text-center p-5 text-danger">Erro de comunicação. Tente novamente</h3></div>`
        );
      }
    })
    .then(() => {
      if (typeof window.promoUrl === 'function') {
        try { promoUrl(); } catch (e) { console.warn('promoUrl error:', e); }
      }

      const openWrap   = document.querySelector('.open_resume_mobile');
      const iconOpen   = openWrap?.querySelector('.icon_basket');
      const iconClose  = openWrap?.querySelector('.icon_basket_close');

      if (flyerCart && iconOpen) {
        iconOpen.onclick = function () {
          flyerCart.classList.add('slide_flyer_cart');
          iconClose?.classList.remove('d-none');
          iconOpen.classList.add('d-none');
        };
      }

      if (flyerCart && iconClose) {
        iconClose.onclick = function () {
          flyerCart.classList.remove('slide_flyer_cart');
          iconClose.classList.add('d-none');
          iconOpen?.classList.remove('d-none');
        };
      }

      if (arrowsBox) show(arrowsBox);
    });
}

document.addEventListener("DOMContentLoaded", function () {
  const current = document.getElementById('current');
  const flyerPlaceholder = document.getElementById('flyer_placeholder');

  if (current && !current.__hoverWired) {
    current.__hoverWired = true;

    const toggleHover = (e, isEnter) => {
      const a = e.target.closest('a[data-sku]');
      if (!a || !current.contains(a)) return;

      const related = e.relatedTarget;
      if (related && a.contains(related)) return;

      const isChildren = String(a.dataset.children) === '1';
      const selector = isChildren
        ? `.container_item[data-sku="GROUP_${a.dataset.posx}-${a.dataset.posy}"]`
        : `.container_item[data-sku="${a.dataset.sku}"]`;

      document.querySelectorAll(selector).forEach(el => {
        el.classList.toggle('active', isEnter);
      });
    };

    current.addEventListener('mouseover', e => toggleHover(e, true));
    current.addEventListener('mouseout',  e => toggleHover(e, false));
  }

  if (flyerPlaceholder && !flyerPlaceholder.__clickWired) {
    flyerPlaceholder.__clickWired = true;

    flyerPlaceholder.addEventListener('click', e => {
      const item = e.target.closest('.container_item');
      if (!item || !flyerPlaceholder.contains(item)) return;
      e.preventDefault();

      const sku = item.dataset.sku;
      // const isGroup = String(item.dataset.group) === '1';

      try {
        if (typeof openGroupSelector === 'function') {
          openGroupSelector(sku);
        } else if (typeof addPointToCart === 'function') {
          addPointToCart(item);
        }
        if (typeof setMoreCartItemCount === 'function') {
          setMoreCartItemCount(1);
        }
      } catch (err) {
        console.error('Erro ao processar clique no ponto do flyer:', err);
      }
    });
  }
});

function placePoints(data, length) {
  const flyerPlaceholder = document.getElementById('flyer_placeholder');
  if (!flyerPlaceholder || !data) return;

  if (!(Number(data.children) === 1)) {
    const div = document.createElement('div');
    div.className = 'container_item';
    div.dataset.sku = String(data.sku);
    div.dataset.group = String(data.group ?? '');

    div.style.top = `${data.posy}%`;
    div.style.left = `${data.posx}%`;

    const icon = document.createElement('i');
    icon.className = 'fas fa-shopping-cart';
    div.appendChild(icon);

    if (String(data.group) === '1' && Number(length) > 0) {
      const badge = document.createElement('span');
      badge.className = 'group-counter';
      badge.textContent = String(length);
      div.appendChild(badge);
    }

    flyerPlaceholder.appendChild(div);
  }
}

function setMoreCartItemCount(quantity) {
  const counter = document.querySelector('.cart-products-count');
  if (!counter) return;

  const flyerCount = Number(counter.dataset.flyer || 0);
  const newCount = flyerCount + Number(quantity);

  counter.dataset.flyer = String(newCount);

  if (typeof window.cartCount === 'function') {
    cartCount();
  }
}

function removeCartItemCount(quantity) {
  const counter = document.querySelector('.cart-products-count');
  if (!counter) return;

  const flyerCount = Number(counter.dataset.flyer || 0);
  const basketCount = Number(counter.dataset.basket || 0);
  const newFlyerCount = Math.max(0, flyerCount - Number(quantity));
  const total = newFlyerCount + basketCount;

  counter.dataset.flyer = String(newFlyerCount);

  if (typeof window.getCartsCount === 'function') {
    getCartsCount(total, basketCount, newFlyerCount);
  } else {
    counter.textContent = total;
  }
}

function openGroupSelector(sku) {
  if (!CID2) return;

  const layout = document.getElementById('flyer_layout');
  const modal  = document.getElementById('group-modal');
  const tbody  = modal?.querySelector('tbody');
  if (!layout || !modal || !tbody) return;

  tbody.replaceChildren();

  const qs = new URLSearchParams({
    action: 'marvanejo_flyer_group',
    id: layout.dataset.promo || '',
    customer: String(CID2),
    sku: String(sku),
    page: String(Number(layout.dataset.page) || 1),
  });

  fetch(`${ENDPOINT}?${qs.toString()}`)
    .then(res =>
      res.ok ? res.json() : res.text().then(t => { throw new Error(`${res.status} ${res.statusText} - ${t}`); })
    )
    .then(data => {
      if (Number(data?.status) !== 1) {
        if (typeof displayError === 'function') displayError(data?.msg || 'Não foi possível carregar o grupo.');
        return;
      }

      (data?.data || []).forEach(item => {
        const tr = document.createElement('tr');

        // SKU
        const tdSku = document.createElement('td');
        tdSku.textContent = item.sku;

        // Título
        const tdTitle = document.createElement('td');
        tdTitle.textContent = item.product?.title ?? '';

        // Unidades
        const tdUnits = document.createElement('td');
        tdUnits.className = 'text-center';
        tdUnits.textContent = item.product?.units ?? '';

        // Preço
        const tdPrice = document.createElement('td');
        tdPrice.className = 'text-right';
        tdPrice.textContent = `${item.product?.price ?? ''}€`;

        // Quantidade (novo)
        const tdQty = document.createElement('td');
        tdQty.className = 'text-center';
        tdQty.innerHTML = `
          <div class="qty-control" style="display:inline-flex;align-items:center;gap:.25rem;">
            <button type="button" class="btn btn-sm" data-action="dec" aria-label="Diminuir quantidade">-</button>
            <input type="number" inputmode="numeric" pattern="[0-9]*" class="form-control form-control-sm" data-role="qty"
                   min="1" step="1" value="1" style="width:4.5rem;text-align:center;">
            <button type="button" class="btn btn-sm" data-action="inc" aria-label="Aumentar quantidade">+</button>
          </div>
        `;

        // Ação
        const tdAction = document.createElement('td');
        tdAction.className = 'text-center';
        const btn = document.createElement('button');
        btn.className = 'btn';
        btn.type = 'button';
        btn.dataset.action = 'add';
        btn.dataset.sku = String(item.sku);
        btn.textContent = 'Adicionar';
        tdAction.appendChild(btn);

        tr.append(tdSku, tdTitle, tdUnits, tdPrice, tdQty, tdAction);
        tbody.appendChild(tr);
      });

      // Event delegation uma vez
      if (!tbody.__wired) {
        tbody.__wired = true;

        // Clicks: + / − / Adicionar
        tbody.addEventListener('click', e => {
          // incrementar/decrementar
          const ctrlBtn = e.target.closest('button[data-action="inc"],button[data-action="dec"]');
          if (ctrlBtn && tbody.contains(ctrlBtn)) {
            const row = ctrlBtn.closest('tr');
            const input = row?.querySelector('input[data-role="qty"]');
            if (input) {
              const min = Number(input.min) || 1;
              let val = Math.max(min, parseInt(input.value || '1', 10) || 1);
              if (ctrlBtn.dataset.action === 'inc') val += 1;
              if (ctrlBtn.dataset.action === 'dec') val = Math.max(min, val - 1);
              input.value = String(val);
            }
            return;
          }

          // adicionar ao carrinho / pontos
          const addBtn = e.target.closest('button[data-action="add"][data-sku]');
          if (addBtn && tbody.contains(addBtn)) {
            const row = addBtn.closest('tr');
            const input = row?.querySelector('input[data-role="qty"]');
            const qty = Math.max(1, parseInt(input?.value || '1', 10) || 1);

            // Passar a quantidade ao handler existente via data-attribute
            addBtn.dataset.qty = String(qty);

            // Chama a tua função existente (assume que lê data-sku e pode ler data-qty)
            addPointToCart(addBtn);
          }
        });

        // Sanitizar input manual
        tbody.addEventListener('change', e => {
          const input = e.target.closest('input[data-role="qty"]');
          if (input && tbody.contains(input)) {
            const min = Number(input.min) || 1;
            let val = Math.max(min, parseInt(input.value || '1', 10) || 1);
            input.value = String(val);
          }
        });
      }

      try {
        if (window.bootstrap?.Modal) {
          const instance = window.bootstrap.Modal.getOrCreateInstance(modal);
          instance.show();
        } else {
          modal.classList.add('show');
          modal.removeAttribute('aria-hidden');
        }
      } catch (err) {
        console.warn('Falha ao abrir modal do grupo:', err);
        modal.classList.add('show');
        modal.removeAttribute('aria-hidden');
      }
    })
    .catch(err => {
      console.error('Erro em marvanejo_flyer_group:', err);
      showLoadingModal('Erro de comunicação. Tente novamente');
      removeLoadingModal();
    });
}

function addPointToCart(elem) {
  if (!CID2) return;

  const layout = document.getElementById('flyer_layout');
  const promo  = layout?.dataset?.promo || '';
  const customer = layout?.dataset?.customer || '';
  const sku = (elem?.dataset?.sku) ? String(elem.dataset.sku) : '';
  const quantity = (elem?.dataset?.qty) ? Number(elem.dataset.qty) : 1;

  showLoadingModal('A adicionar o produto ao carrinho');

  const body = new URLSearchParams({
    action: 'marvanejo_add_to_cart',
    id: promo,
    customer: String(CID2),
    sku,
    quantity,
  });

  fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Accept: 'application/json, text/plain, */*',
    },
    body: body.toString(),
  })
    .then(res =>
      res.ok ? res.json() : res.text().then(t => { throw new Error(`${res.status} ${res.statusText} – ${t}`); })
    )
    .then(data => {
      document.querySelector('#flyer_cart_container .alert')?.remove();

      if (Number(data?.status) === 1) {
        if (typeof getPointsFromCart === 'function') {
          try { getPointsFromCart(promo, customer); } catch (e) { console.error(e); }
        }

        if (typeof getCartsCount === 'function') {
          try { getCartsCount(); } catch (e) { console.error(e); }
        }
      } else {
        alert(data?.msg || 'Não foi possível adicionar ao carrinho.');
      }
    })
    .catch(err => {
      console.error('Erro em marvanejo_add_to_cart:', err);
      showLoadingModal('Erro de comunicação. Tente novamente');
    })
    .finally(() => {
      removeLoadingModal();

      if (typeof ajustCartLayout === 'function') {
        try { ajustCartLayout(); } catch (e) { console.error(e); }
      }
    });
}

function getPointsFromCart(id, customer) {
  if (!CID2) return;

  const layout       = document.getElementById('flyer_layout');
  const flyerCart    = document.getElementById('flyer_cart');
  const container    = document.getElementById('flyer_cart_container');
  const totalSpan    = document.querySelector('#flyer_cart_total span');
  const flushParents = Array.from(document.querySelectorAll('a[data-flush]'))
    .map(a => a.parentElement)
    .filter(Boolean);

  if (!container || !flyerCart) return;

  container.replaceChildren();
  flyerCart.querySelectorAll('button').forEach(b => (b.disabled = true));
  flushParents.forEach(el => (el.style.display = 'none'));

  const qs = new URLSearchParams({
    action: 'marvanejo_get_cart',
    id: layout?.dataset?.promo || String(id || ''),
    customer: String(CID2),
  });

  fetch(`${ENDPOINT}?${qs.toString()}`)
    .then(res =>
      res.ok ? res.text() : res.text().then(t => { throw new Error(`${res.status} ${res.statusText} – ${t}`); })
    )
    .then(text => {
      const data = typeof text === 'string' ? JSON.parse(text) : text;

      if (Number(data?.status) !== 1) {
        alert(data?.msg || 'Não foi possível carregar o carrinho.');
        return;
      }

      const items = Array.isArray(data.data) ? data.data : [];

      if (items.length > 0) {
        for (let i = 0; i < items.length; i++) {
          const it = items[i];
          try {
            generateCartItem(
              it.product?.title,
              it.sku,
              it.quantity,
              it.price,
              it.product?.vat,
              it.product?.offer_threshold,
              it.product?.offer_sku,
              it.product?.offer_quantity
            );
          } catch (err) {
            console.error('Erro em generateCartItem:', err, it);
          }
        }

        if (typeof ajustCartLayout === 'function') {
          try { ajustCartLayout(); } catch (e) { console.error(e); }
        }

        if (totalSpan) totalSpan.textContent = Number(data.total || 0).toFixed(2);

        flyerCart.querySelectorAll('button').forEach(b => (b.disabled = false));
        flushParents.forEach(el => (el.style.display = ''));
      } else {
        const alert = document.createElement('div');
        alert.className = 'alert alert-warning text-center';
        alert.setAttribute('role', 'alert');
        alert.textContent = 'Compra Vazia';
        container.appendChild(alert);

        flushParents.forEach(el => (el.style.display = 'none'));
        if (totalSpan) totalSpan.textContent = '0.00';
        flyerCart.querySelectorAll('button').forEach(b => (b.disabled = true));
      }
    })
    .catch(err => {
      console.error('Erro de comunicação em marvanejo_get_cart:', err);
      showLoadingModal('Erro de comunicação. Tente novamente');
      removeLoadingModal();
    });
}

function generateCartItem(
  title, 
  sku, 
  quantity, 
  price, 
  vat, 
  min_qty, 
  offer_sku, 
  offer_qty
) {
  const container = document.getElementById('flyer_cart_container');
  if (!container) return false;

  const item = document.createElement('div');
  item.className = 'cart-item';
  item.dataset.sku = String(sku);

  const inputQty = document.createElement('input');
  inputQty.type = 'number';
  inputQty.className = 'flyer_quantity';
  inputQty.value = quantity;
  inputQty.dataset.sku = String(sku);

  const h5 = document.createElement('h5');
  h5.innerHTML = `
    ${title}<br>
    IVA ${vat} <span>${sku}</span> 
    <a href="#" data-sku="${sku}">ELIMINAR</a>
  `;

  if (offer_sku && offer_sku.trim() !== '') {
    offer_sku = offer_sku.trim();
    sku = sku.trim();

    const rat = Math.floor(quantity / offer_qty);
    const next = Math.ceil(quantity / offer_qty);

    let offerLogic = '';

    if (offer_sku === sku) {
      offerLogic = `de ${(min_qty * next)} na compra de ${(offer_qty * next)}<br>`;

      if (quantity >= offer_qty) {
        offerLogic += `<span style="color:#333">Já inclui a oferta de ${(min_qty * rat)} unidades</span>`;
      }
    } else {
      offerLogic = `de ${(min_qty * next)} artigos «${offer_sku}» na compra de ${(offer_qty * next)} deste<br>`;

      if (quantity >= offer_qty) {
        offerLogic += `<span style="color:#333">Já inclui a oferta de ${(min_qty * rat)} unidades do artigo «${offer_sku}»</span>`;
      }
    }

    const offerSpan = document.createElement('span');
    offerSpan.className = 'text-primary';
    offerSpan.innerHTML = `<i class="fa fa-gift"></i> <strong>OFERTA ${offerLogic}</strong>`;
    h5.appendChild(document.createElement('br'));
    h5.appendChild(offerSpan);
  }

  const inputPrice = document.createElement('input');
  inputPrice.type = 'text';
  inputPrice.value = `${price}€`;
  inputPrice.disabled = true;

  const priceNum = parseFloat(price);
  let total = 0;

  if (vat > 0) {
    const iva = priceNum * (vat / 100);
    const sub = priceNum + iva;
    total = (sub * quantity).toFixed(2);
  } else {
    total = (priceNum * quantity).toFixed(2);
  }

  const inputTotal = document.createElement('input');
  inputTotal.type = 'text';
  inputTotal.value = `${total}€`;
  inputTotal.disabled = true;

  item.append(inputQty, h5, inputPrice, inputTotal);
  container.appendChild(item);

  const removeLink = h5.querySelector(`a[data-sku="${sku}"]`);

  if (removeLink) {
    removeLink.addEventListener('click', e => {
      e.preventDefault();
      if (typeof window.removePointFromCart === 'function') {
        try { removePointFromCart(e); } catch (err) { console.error('Erro ao remover item:', err); }
      }
    });
  }

  inputQty.addEventListener('change', e => {
    if (typeof window.updatePointQuantity === 'function') {
      try { updatePointQuantity(e); } catch (err) { console.error('Erro ao atualizar quantidade:', err); }
    }
  });

  return true;
}

function updatePointQuantity(e) {
  if (!CID2) return;

  const elem = e.target;
  const layout = document.getElementById('flyer_layout');
  if (!elem || !layout) return;

  const promoId = layout.dataset.promo || '';
  const sku = elem.dataset.sku || '';
  const currentValue = Number(elem.value || 0);

  const prevValue = Number(elem.dataset.prev ?? elem.defaultValue ?? currentValue);

  const body = new URLSearchParams({
    action: 'marvanejo_update_cart_quantity',
    id: String(promoId),
    customer: String(CID2),
    sku: String(sku),
    quantity: String(currentValue),
  });

  fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Accept: 'application/json, text/plain, */*',
    },
    body: body.toString(),
  })
    .then(res =>
      res.ok ? res.json() : res.text().then(t => { throw new Error(`${res.status} ${res.statusText} – ${t}`); })
    )
    .then(data => {
      console.log(data);

      if (Number(data?.status) === 1) {
        if (typeof getPointsFromCart === 'function') {
          try { getPointsFromCart(promoId, layout.dataset.customer || ''); } catch (err) { console.error(err); }
        }

        const diff = prevValue - currentValue;
        if (prevValue > currentValue) {
          if (typeof setMoreCartItemCount === 'function') setMoreCartItemCount(diff);
        } else if (prevValue < currentValue) {
          const inc = currentValue - prevValue;
          if (typeof removeCartItemCount === 'function') removeCartItemCount(inc);
        }

        elem.dataset.prev = String(currentValue);
        elem.defaultValue = String(currentValue);
      } else {
        alert(data?.msg || 'Não foi possível atualizar a quantidade.');
      }
    })
    .catch(err => {
      console.error('Erro de comunicação em marvanejo_update_cart_quantity:', err);
      showLoadingModal('Erro de comunicação. Tente novamente');
      removeLoadingModal();
    });
}

function removePointFromCart(e) {
  if (!CID2) return;
  e.preventDefault();

  const elem = e.target;
  const layout = document.getElementById('flyer_layout');
  const promoId = layout?.dataset.promo || '';
  if (!layout || !elem) return;

  elem.style.display = 'none';

  const cartItem = elem.closest('.cart-item');
  const qtyInput = cartItem ? cartItem.querySelector('input[type="number"]') : null;
  const productTotal = Number(qtyInput?.value || 0);

  const sku = elem.dataset.sku || '';

  const body = new URLSearchParams({
    action: 'marvanejo_remove_from_cart',
    id: String(promoId),
    customer: String(CID2),
    sku: String(sku),
  });

  fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Accept: 'application/json, text/plain, */*',
    },
    body: body.toString(),
  })
    .then(res =>
      res.ok ? res.json() : res.text().then(t => { throw new Error(`${res.status} ${res.statusText} – ${t}`); })
    )
    .then(data => {
      if (Number(data?.status) === 1) {
        if (typeof getPointsFromCart === 'function') {
          try { getPointsFromCart(promoId, CID2); } catch (err) { console.error(err); }
        }

        if (typeof setMoreCartItemCount === 'function') {
          setMoreCartItemCount(productTotal);
        }
      } else {
        elem.style.display = '';
        alert(data?.msg || 'Não foi possível remover o item.');
      }
    })
    .catch(err => {
      elem.style.display = '';
      console.error('Erro de comunicação em marvanejo_remove_from_cart:', err);
      showLoadingModal('Erro de comunicação. Tente novamente');
      removeLoadingModal();
    })
    .finally(() => {
      if (typeof ajustCartLayout === 'function') {
        try { ajustCartLayout(); } catch (e2) { console.error(e2); }
      }
    });
}

function flushCart(e) {
  if (!CID2) return;
  e.preventDefault();

  const trigger = e.target;
  const parent = trigger?.parentElement;
  if (parent) parent.style.display = 'none';

  let totalItemsFlyer = 0;
  document.querySelectorAll('.cart-item input.flyer_quantity').forEach(input => {
    totalItemsFlyer += Number(input.value || 0);
  });

  const layout = document.getElementById('flyer_layout');
  const promoId = layout?.dataset?.promo || '';

  const body = new URLSearchParams({
    action: 'marvanejo_flush_cart',
    id: String(promoId),
    customer: String(CID2),
  });

  fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Accept: 'application/json, text/plain, */*',
    },
    body: body.toString(),
  })
    .then(res =>
      res.ok ? res.json() : res.text().then(t => { throw new Error(`${res.status} ${res.statusText} – ${t}`); })
    )
    .then(data => {
      if (Number(data?.status) === 1) {
        if (typeof getPointsFromCart === 'function') {
          try { getPointsFromCart(promoId, CID2); } catch (err) { console.error(err); }
        }
        if (typeof setMoreCartItemCount === 'function') {
          try { setMoreCartItemCount(totalItemsFlyer); } catch (err) { console.error(err); }
        }
      } else {
        if (parent) parent.style.display = '';
        alert(data?.msg || 'Não foi possível limpar o carrinho.');
      }
    })
    .catch(err => {
      if (parent) parent.style.display = '';
      console.error('Erro de comunicação em marvanejo_flush_cart:', err);
      showLoadingModal('Erro de comunicação. Tente novamente');
      removeLoadingModal();
    });
}

function getUrlParameter(name) {
  const params = new URLSearchParams(window.location.search);
  if (!params.has(name)) return false;
  const v = params.get(name);
  return v === '' ? true : decodeURIComponent(v);
}

document.addEventListener('DOMContentLoaded', function () {
  const autocart = document.getElementById('autocart');
  if (!autocart) return;

  const tbody = autocart.querySelector('table tbody');
  if (!tbody) return;

  tbody.innerHTML = `
    <tr>
      <td colspan="6">
        <p class="p-5 text-center">
          <i class="fa fa-spinner fa-spin fa-3x text-muted"></i>
        </p>
      </td>
    </tr>`;

  const params = new URLSearchParams(location.search);
  const id = params.get('id');

  if (!id) {
    tbody.innerHTML = `
      <tr>
        <td colspan="6">
          <div class="alert alert-danger mt-3">
            <h3 class="text-center p-5 m-0 text-danger">Identificação da promoção inválida</h3>
          </div>
        </td>
      </tr>`;
    return;
  }

  const qs = new URLSearchParams({
    action: 'marvanejo_auto',
    customer: String(autocart.dataset.customer || ''),
    id: String(id),
  });

  fetch(`${ENDPOINT}?${qs.toString()}`)
    .then(res =>
      res.ok ? res.text() : res.text().then(t => { throw new Error(`${res.status} ${res.statusText} - ${t}`); })
    )
    .then(text => {
      const data = typeof text === 'string' ? JSON.parse(text) : text;

      if (Number(data?.status) !== 1) {
        tbody.innerHTML = `
          <tr>
            <td colspan="6">
              <div class="alert alert-danger mt-3">
                <h3 class="text-center p-5 m-0 text-danger">${data?.msg || 'Falha ao carregar a promoção.'}</h3>
              </div>
            </td>
          </tr>`;
        return;
      }

      const products = Array.isArray(data.products) ? data.products : [];
      tbody.innerHTML = '';

      for (let i = 0; i < products.length; i++) {
        const p = products[i];
        const tr = document.createElement('tr');
        tr.dataset.sku = String(p.sku);

        const tdImg = document.createElement('td');
        tdImg.dataset.image = String(p.shopify_id || '');
        tdImg.innerHTML = `<img src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=" width="60" height="60" />`;

        const tdTitle = document.createElement('td');
        tdTitle.innerHTML = `${p.title || ''}<br>${p.sku || ''}`;

        const tdQty = document.createElement('td');
        tdQty.dataset.quantity = String(p.quantity || 0);
        tdQty.innerHTML = `
          <input type="number" value="${p.quantity || 0}" data-sku="${p.sku || ''}">
          <span>${p.units || ''}</span>
        `;

        const tdPrice = document.createElement('td');
        tdPrice.dataset.price = String(p.price || 0);
        tdPrice.textContent = `${Number(p.price || 0)}€`;

        const tdSubtotal = document.createElement('td');
        tdSubtotal.dataset.subtotal = String(p.subtotal || 0);
        tdSubtotal.textContent = `${Number(p.subtotal || 0)}€`;

        tr.append(tdImg, tdTitle, tdQty, tdPrice, tdSubtotal);
        tbody.appendChild(tr);
      }

      const last = document.createElement('tr');
      last.innerHTML = `
        <td></td>
        <td></td>
        <td data-all="${data.count}">${data.count}</td>
        <td></td>
        <td data-total="${data.total}">${Number(data.total || 0).toFixed(2)}€</td>
      `;
      tbody.appendChild(last);
    })
    .catch(err => {
      console.error('Erro em marvanejo_auto:', err);
      tbody.innerHTML = `
        <tr>
          <td colspan="6">
            <div class="alert alert-danger mt-3">
              <h3 class="text-center p-5 m-0 text-danger">Erro de comunicação. Tente novamente!</h3>
            </div>
          </td>
        </tr>`;
    });

  autocart.addEventListener('change', function (e) {
    const input = e.target.closest('input[type="number"]');
    if (!input || !autocart.contains(input)) return;
    if (typeof window.updateAutocart === 'function') {
      try { updateAutocart(e); } catch (err) { console.error('updateAutocart falhou:', err); }
    }
  });
});

function updateAutocart(event) {
  if (!CID) return;

  const input = (event && event.target) || this;
  if (!input) return;

  const sku = input.dataset.sku || '';
  const quantity = Number(input.value || 0);

  const params = new URLSearchParams(location.search);
  const promo = params.get('id');
  if (!promo) return false;

  const autocart = document.getElementById('autocart');
  const customer = autocart?.dataset?.customer || '';

  const body = new URLSearchParams({
    action: 'marvanejo_auto_update',
    customer: String(customer),
    promo: String(promo),
    sku: String(sku),
    quantity: String(quantity),
  });

  fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      Accept: 'application/json, text/plain, */*',
    },
    body: body.toString(),
  })
    .then(res =>
      res.ok ? res.text() : res.text().then(t => { throw new Error(`${res.status} ${res.statusText} – ${t}`); })
    )
    .then(text => {
      const data = typeof text === 'string' ? JSON.parse(text) : text;

      if (Number(data?.status) !== 1) {
        alert('Erro');
        return;
      }

      const p = data.products || {};
      if (p.quantity != null) {
        const row = document.querySelector(`#autocart tr[data-sku="${p.sku}"]`);
        const tdQty = row?.querySelector('td[data-quantity]');
        const tdSubtotal = row?.querySelector('td[data-subtotal]');

        if (tdQty) tdQty.dataset.quantity = String(p.quantity);
        if (tdSubtotal) {
          tdSubtotal.dataset.subtotal = String(Number(p.subtotal).toFixed(2));
          tdSubtotal.textContent = `${Number(p.subtotal).toFixed(2)}€`;
        }

        const tdTotal = document.querySelector('#autocart td[data-total]');
        if (tdTotal) {
          tdTotal.dataset.total = String(data.total);
          tdTotal.textContent = `${Number(data.total).toFixed(2)}€`;
        }

        const tdAll = document.querySelector('#autocart td[data-all]');
        if (tdAll) {
          tdAll.dataset.all = String(data.count);
          tdAll.textContent = String(data.count);
        }
      }
    })
    .catch(err => {
      console.error('Erro em marvanejo_auto_update:', err);
      alert('Erro');
    });
}
